import React from "react";
import moment from "moment";

import numeral from "numeral";

import { Popover, OverlayTrigger } from "react-bootstrap";
import { Button, Icon, TileTitle, Tile, TileBody, TileItem } from "aible";
import { getColor as getTileColor } from "aible/Tile/Tile";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import WaterFall from "components/Waterfall/Waterfall";

import createRunIcon from "images/tileIcons/model.svg";

import getStyles from "components/Home/Utils/getStyles";
import CreateTile from "components/Tiles/CreateTile";
import {
  InfoItem,
  InfoIcon,
  getPrettyNumber,
  NumberDisplay,
  ErrorOverlay,
  DeleteButton
} from "components/Home/Utils/Utils";

import styles from "./style.module.css";

const runStyles = getStyles("project");

export default class OptimizerTile extends React.Component {
  handleOnClick(event) {
    const { onHover, onClick } = this.props;
    onHover && onHover(undefined);
    return onClick(event);
  }

  handleDelete(event) {
    event.stopPropagation();
    const { handleDelete, onHover } = this.props;

    if (handleDelete) {
      onHover && onHover(undefined);
      return handleDelete(event);
    } else return;
  }

  render() {
    const {
      data,
      onClick,
      onHover,
      noHover,
      handleDelete,
      shouldHighlight,
      hideDelete,
      isHighlight,
      isCreate,
      isCreateDisabled,
      isConsumer,
      // `optimized` is undefined unless isConsumer is true
      optimized,
      overallBusinessContraints
    } = this.props;

    if (isCreate) {
      return <CreateOptimizerTile isCreateDisabled={isCreateDisabled} {...this.props} onClick={onClick} />;
    }

    if (!data) {
      return <React.Fragment></React.Fragment>;
    }

    const noPermissions = !data.segment_count;
    const canDelete = data.permissions && data.permissions.can_delete;
    const segmentCount = Math.max(0, data.segment_count - 1);

    const impact = optimized && optimized.profit;
    const impactDelta = optimized && optimized.profitDelta;
    const unitLabel = optimized ? optimized.unitLabel : "";

    return (
      <Tile
        onClick={onClick && !noPermissions ? (e) => this.handleOnClick(e) : undefined}
        onMouseEnter={() => {
          return onHover && onHover(data.id);
        }}
        onMouseLeave={() => {
          return onHover && onHover(undefined);
        }}
        buttonText={"Open Project"}
        handleDelete={handleDelete && !noPermissions && canDelete ? (e) => this.handleDelete(e) : undefined}
        active={isHighlight}
        noHover={noHover}
        shouldHighlight={shouldHighlight}
        hideDelete={hideDelete}
      >
        <TileTitle
          title={data.name + " (" + data.id + ")"}
          icon={noPermissions ? "projectNoPermissions" : segmentCount ? "projectSegments" : "projectNoSegments"}
          color={noPermissions ? "default" : "project"}
        >
          {/* <div className={styles.optimizerTitleWrapper}>
            <div className={styles.optimizerTitle}>{data.name}</div>
            <div className={styles.optimizerSubtitle}>{`${segmentCount} Subgroup${(segmentCount !== 1 ? "s" : "")}`}</div>
          </div> */}
          {data.name}
        </TileTitle>
        <TileBody
          loadingText={"Generating Frontiers..."}
          color={"project"}
          isError={noPermissions}
          errorText={"You don't have permission to access this project"}
        >
          {isConsumer ? (
            <div className={styles.tileBadge}>
              <div className={styles.tileBadgeTitle} style={{ marginLeft: 0 }}>
                <FontAwesomeIcon icon={impactDelta >= 0 ? faArrowUp : faArrowDown} />
              </div>
              <div className={styles.tileBadgeTitle}>{unitLabel + numeral(impact).format("0.0a")}</div>
              <div className={styles.tileBadgeSubTitle}>
                {`${impactDelta >= 0 ? "+" : ""}${numeral(impactDelta).format("0.0a")}`}
              </div>
            </div>
          ) : (
            <React.Fragment />
          )}
          <TileItem icon={segmentCount ? "layers" : "layersNone"}>
            {`${segmentCount} Subgroup${segmentCount !== 1 ? "s" : ""}`}
          </TileItem>
          <TileItem icon={"userGroup"}>
            {(data.roles || []).length + " contributor" + ((data.roles || []).length !== 1 ? "s" : "")}
          </TileItem>
          <TileItem icon={"user"}>{data.created_by && data.created_by.fullname}</TileItem>
          <TileItem icon={"calendar"} overlay={moment.utc(data.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
            {moment.utc(data.created_date).local().fromNow()}
          </TileItem>
        </TileBody>
      </Tile>
    );
  }
}

export class CreateOptimizerTile extends React.PureComponent {
  render() {
    const { onClick, isCreateDisabled } = this.props;
    const text = "Create Project";
    return (
      <CreateTile
        onClick={onClick}
        noPermissions={isCreateDisabled}
        noPermissionsText={"You don't have permission to create a project in this folder."}
        buttonText={text}
        loadingText={text}
        img={
          <div style={{ flexShrink: 0, fontSize: "60px", color: styles.purple }}>
            <Icon type={"layersPurple"} size={60} />
          </div>
        }
      />
    );
  }
}
